define('usuario-default-resource',['i18n-provider', 'app-route-provider', 'notify-service', '_', 'angular-storage'], function() {

  var app = angular.module('usuario.default.resource', ['ui.router', 'i18n.provider', 'app.route.provider', 'ngStorage', 'notify.service']);

  app.factory('UsuarioDefault', ['$q', '$http', '$location', '$state', '$localStorage', '$rootScope', 'i18n', 'appRoute', 'notify', 
    function($q, $http, $location, $state, $localStorage, $rootScope, i18n, appRoute, notify) {

      $rootScope.$on('$locationChangeSuccess', function(event, toUrl, fromUrl) {
        var fromUri = new URI(fromUrl);
        $rootScope.previousUrl = fromUrl;
        $rootScope.previousUrlPath = fromUri.path();
      });

      return {
        check: function() {
          return $q(function(resolve, reject) {
            if (!$localStorage.token) {
              reject(new Error('No token provided'));
            } else {
              //$state.go('usuario-dashboard');
              $http.get(appRoute.linkTo('usuarioDefault.check')).success(function(data) {
                resolve(data);
              })['catch'](function(error) {
                reject(error);
              });
            }
          })['catch'](function(error) {
            $state.go('dashboard');
          });
        }
      };
    }
  ]);

});

